import React, {Fragment} from 'react'
import {Flex, Stack} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import RecommendedProducts from '../../../components/recommended-products'

const CartRecommendation = ({cartRecommenderId, openQuickAddModal = false}) => {
    return (
        <Flex data-testid="sf-cart-recommendation">
            <Fragment>
                {openQuickAddModal && (
                    <Stack
                        spacing="20px"
                        className="cart-recommendations-wrapper"
                        margin={{
                            base: '0'
                        }}
                        maxWidth="-webkit-fill-available"
                        width="100%"
                        overflow="hidden"
                        sx={{
                            '.list-title': {
                                fontSize: '30px',
                                fontWeight: '400',
                                fontFamily: 'heading',
                                color: 'black.100',
                                padding: 0,
                                letterSpacing: '0.125px',
                                display: 'flex',
                                alignItems: 'center'
                            },
                            '.spinner img': {
                                width: '45px',
                                height: '45px'
                            },
                            'div[data-testid="product-scroller"]': {
                                paddingY: '0px'
                            },
                            img: {
                                width: '175px',
                                height: '250px'
                            },
                            '.swiper-slide': {
                                width: '175px !important',
                                marginRight: '0px !important'
                            },
                            'div[role="radiogroup"]': {
                                display: 'none'
                            },
                            '.info-wrapper': {
                                margin: '0 10px'
                            },
                            '.display-price-wrapper': {
                                marginRight: '6.58px'
                            },
                            '.product-name': {
                                margin: '10px 0',
                                fontSize: '18px',
                                minHeight: '45px',
                                letterSpacing: '0.075px'
                            },
                            '.info-wrapper b': {
                                fontSize: '16px',
                                letterSpacing: '0.08px',
                                lineHeight: '25px'
                            },
                            '.swiper-wrapper': {
                                paddingLeft: '0 !important',
                                gap: '10px'
                            },
                            '.swiper': {
                                padding: '0px !important',
                                margin: '0 !important',
                                position: 'static'
                            },
                            '.swiper-parent': {
                                width: '100%',
                                border: 'none',
                                padding: '0',
                                margin: '20px 0 0 0'
                            },
                            '.swiper-button-next, .swiper-button-prev': {
                                top: '0 !important',
                                opacity: '1 !important',
                                display: 'flex !important',
                                boxShadow: 'none !important',
                                backgroundColor: 'transparent !important',
                                '&.swiper-button-disabled': {
                                    opacity: '0.35 !important',
                                    display: 'flex !important'
                                }
                            },
                            '.swiper-button-next': {
                                right: {base: '5px !important', lg: '-10px !important'},
                                left: 'initial !important'
                            },
                            '.swiper-button-prev': {
                                right: {base: '52px !important', lg: '37px !important'},
                                left: 'initial !important'
                            },
                            '.tiles-skeleton-wrapper': {
                                marginLeft: '0px',
                                gap: '20px',
                                marginTop: '0px'
                            },
                            '.wishlist-wrapper': {
                                display: 'none !important'
                            },
                            '.skeleton-tile-name': {
                                width: '100px',
                                height: '22px'
                            },
                            '.skeleton-tile-price': {
                                height: '20px'
                            },
                            '.title-skeleton': {
                                margin: '0 0 15px 0',
                                height: '30px',
                                width: '205px'
                            },
                            '.add-only-btn': {
                                height: '26px',
                                fontSize: '13px',
                                padding: '2px 15px'
                            },
                            '.quick-add-wrapper': {
                                left: 0
                            }
                        }}
                    >
                        <RecommendedProducts
                            hideArrows={false}
                            itemWidth="175px"
                            quickAddLabel={false}
                            openQuickAddModal={openQuickAddModal}
                            showImageSlider={true}
                            recommender={cartRecommenderId}
                            titleMinHeight="42px"
                            mx={0}
                        />
                    </Stack>
                )}
            </Fragment>
        </Flex>
    )
}

CartRecommendation.propTypes = {
    cartRecommenderId: PropTypes.string,
    openQuickAddModal: PropTypes.bool
}

export default CartRecommendation
